import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export const czechTimeZone = "Europe/Prague";

export const startOfCzechDay = (date: Date = new Date()): Date => {
  const czechDate = utcToZonedTime(date, czechTimeZone);
  const dateString = format(czechDate, "yyyy-MM-dd 00:00:00");

  return zonedTimeToUtc(dateString, czechTimeZone);
};

// tslint:disable-next-line:no-identical-functions
export const endOfCzechDay = (date: Date = new Date()): Date => {
  const czechDate = utcToZonedTime(date, czechTimeZone);
  const dateString = format(czechDate, "yyyy-MM-dd 23:59:59");

  return zonedTimeToUtc(dateString, czechTimeZone);
};

export const disabledDaysRange = (after: Date, before?: Date) => ({
  before: before ?? czechTodayDate(),
  after: after,
});

export const czechTodayDate = () => utcToZonedTime(new Date(), czechTimeZone);
export const czechDate = (value: Date | string | number) => utcToZonedTime(value, czechTimeZone);
